<template>
  <Modal size="medium">
    <template v-slot:header>
      <div class="d-flex justify-content-between w-100 align-items-center">
        <div></div>
        <h1 class="fs-3 fw-bold mr-5">Jury Instructions Report</h1>
        <button class="btn btn-xl btn-gray" @click="emitClose">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>
    
    <template v-slot:body >
      <div class="d-flex flex-column p-5">
        <div class="mb-4">
          <button class="btn" :class="allOptionsSelected ? 'btn-primary-outline':' btn-primary'" @click="selectAll">
            {{ allOptionsSelected ? 'Uncheck All' : 'Select All' }}
          </button>
        </div>
        
        <ul class="m-0 p-0 mb-5 x" v-if="!loading">
          <li
            class="d-flex align-items-center mb-3 fs-5"
            v-for="key in Object.keys(switchObject)"
            :key="key"
          >
            <input
              type="checkbox"
              class="mr-3 mb-0"
              :id="key"
              v-model="switchObject[key]"
            />
            <label class="fs-5 m-0 p-0" :for="key">{{ key }}</label>
          </li>
          <br />
          <li class="d-flex align-items-center mb-3 fs-5">
            <input
              type="checkbox"
              class="mr-3 mb-0"
              id="pageNumber"
              v-model="includePageNumbers"
            />
            <label class="fs-5 m-0 p-0" for="pageNumber">Include Page Numbers</label>
          </li>
        </ul>
        
        <div>
          <button
            v-if="!loading"
            class="btn btn-primary btn-xl"
            @click="generateReport"
          >
            Generate Report
          </button>
          <LoadingButton v-else class="btn btn-primary btn-xl" style="height: 37.5px; width: 149.8 ">
            Generate Report
          </LoadingButton>
        </div>
      </div>
    </template>
    
  </Modal>
</template>

<script>
import axios from "axios";
import LoadingButton from "../../components/utils/LoadingButton.vue";
import Modal from "../../components/utils/Modal.vue";
export default {
  name: "JuryInstructionsReportModal",
  props: ["juryInstructions"],
  components: {
    LoadingButton, Modal
  },
  computed: {
    allOptionsSelected() {
      let returnValue = true;
      Object.keys(this.switchObject).forEach((key) => {
        if (!this.switchObject[key]) {
          returnValue = false;
        }
      });
      return returnValue;
    },
  },
  data() {
    return {
      loading: false,
      switchObject: {},
      subsections: [],
      allSelected: true,
      includePageNumbers: true,
      // Your data properties go here
    };
  },
  methods: {
    // Your methods go here
    emitClose() {
      this.$emit("close");
    },
    async generateReport() {
      this.loading = true;
      const selectedSubsections = Object.keys(this.switchObject).filter(
        (key) => this.switchObject[key]
      );
      this.juryInstructions.forEach((inst) => {
        inst.subsections = this.subsections.filter(
          (subsection) =>
            selectedSubsections.includes(subsection.SectionTitle) &&
            subsection.JuryInstructionId == inst.Id
        );
      });
      const report = await axios
        .post(
          process.env.VUE_APP_ENDPOINT + "/api/reports/printJuryInstructions",
          {
            instructionsArray: this.juryInstructions,
            includePageNumbers: this.includePageNumbers,
          },
          {
            headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
          }
        )
        .then(async (response) => {
          const path = response.data?.fileName;
          await fetch(process.env.VUE_APP_ENDPOINT + `/api/reports/download/${path}`, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("user_token"),
              "Content-Type": "application/pdf",
            },
          })
            .then((r) => r.blob())
            .then(async (result) => {
              let blob = await new Blob([result], { type: "application/pdf" });
              let link = window.URL.createObjectURL(blob);
              // console.log(link);
              window.open(link, "_blank");
              this.loading = false;
            });
        });
    },
    selectAll() {
      if (this.allOptionsSelected) {
          
        
      Object.keys(this.switchObject).forEach((key) => {
        this.switchObject[key] = false;
      });
    } else {
      Object.keys(this.switchObject).forEach((key) => {
        this.switchObject[key] = true;
      });
        }
    },
  },
  async mounted() {
    this.loading = true;
    const subsections = await axios.post(
      process.env.VUE_APP_ENDPOINT + "/api/juryInstructions/subsections/many",
      {
        instructionIds: this.juryInstructions.map((instruction) => instruction.Id),
      },
      {
        headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
      }
    );
    this.subsections = subsections.data;
    const uniqueSubsections = [];
    subsections.data.forEach((subsection) => {
      if (!uniqueSubsections.find((us) => us.SectionTitle === subsection.SectionTitle)) {
        uniqueSubsections.push(subsection);
      }
    });
    uniqueSubsections.forEach((subsection) => {
      this.switchObject[subsection.SectionTitle] = false;
    });
    // this.subsections.forEach(subsection => {
    //     this.switchObject[subsection.Id] = false;
    // });
    this.loading = false;
    // Code to run when the component is mounted goes here
  },
};
</script>

<style scoped>
/* Your component-specific styles go here */
.modal-bounce-enter-active {
  animation: bounce-in 0.7s;
}
.modal-bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.bounce-enter-active {
  animation: bounce-in 5.5s;
}
.bounce-leave-active {
  animation: bounce-in 1.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

.modal-backdrop {
  position: fixed;
  z-index: 110;
  line-height: 1;
  -webkit-backdrop-filter: opacity(80%) blur(8px);

  position: fixed;
  top: calc(25% / 2);
  bottom: calc(25% / 2);
  left: calc(25% / 2);
  z-index: 131;

  width: calc(75%);

  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
}

.modal-custom {
  box-shadow: 2px 2px 20px 1px;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  max-height: 80vh;
  overflow-y: none;
}

.alpha60 {
  /* Fallback for web browsers that doesn't support RGBa */
  background: rgb(0, 0, 0);
  /* RGBa with 0.6 opacity */
  background: rgba(0, 0, 0, 0.6);
  /* For IE 5.5 - 7*/
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);
  /* For IE 8*/
  -ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000)";
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1px 1px;
}

.modal-body {
  position: relative;
  padding: 10px 10px;

  max-height: 90%;
  overflow-y: auto;
  min-height: 90%;

  height: 90%;

  left: 0px;
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 5px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}




.transparency {
  opacity: 15%;
}

.big-modal {
  max-width: 95%;
  z-index: 50;
}



.clickable:hover {
  cursor: pointer;
}
</style>
